import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ({ t }) {
  return (
    <section id="faq" className="bg-white border-b-2 border-black" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="text-xs font-bold tracking-[0.22em] text-[#E11D2E]">{t.faq.eyebrow}</div>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1]">
          {t.faq.title}
        </h2>

        <Accordion type="single" collapsible className="mt-10 border-2 border-black">
          {t.faq.items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b-2 border-black last:border-b-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="px-5 md:px-6 py-5 text-left font-display text-lg md:text-xl hover:no-underline hover:bg-zinc-50 data-[state=open]:bg-black data-[state=open]:text-white">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="px-5 md:px-6 pb-5 text-zinc-700 text-[15px] leading-relaxed">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
